import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import {NavLink} from "util/router";
import Nav from 'react-bootstrap/Nav'
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import moment from 'moment';
import { Switch, Route } from "util/router.js";
import ClassDashboard from 'components/ClassDashboard'
import * as rp from 'request-promise';
import STRIPE_IMAGE from "assets/img/connect_stripe.png"
import PaymentsTable from "components/PaymentsTable";
import {Helmet} from 'react-helmet'
import StripePaymentsTable from 'components/StripePaymentsTable'

const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID;

const useStyles = makeStyles(styles);


function PaymentsPage(props) {

    

    // const classes = useStyles();

    const { history, match } = props;
    console.log("Match: ", match)

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday]',
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do'
        }
    });
    
    const revenueActive = match.isExact
    const bookingsActive = !match.isExact
    
    // const instructor = useSelector(state => state.instructor.instructor);

    return (
        <div className="container">
        <Nav variant="pills" className="nav nav-pills">
            <Nav.Item>
                <Nav.Link className={revenueActive ? "active" : ""} to={`${match.url}`} onClick={() => history.push(match.url)}>
                    <span style={{color:(revenueActive ? "white" : "")}} >Revenue</span>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link className={bookingsActive ? "active" : ""} to={`${match.url}/bookings`} onClick={() => history.push(`${match.url}/bookings`)}>
                    <span style={{color:(bookingsActive ? "white" : "")}} >Bookings</span>
                </Nav.Link>
            </Nav.Item>
        </Nav>
        <Switch>
            <Route path={`${match.url}/bookings`}>
                {/* <div>Wahoo</div> */}
                <div>

                    <Helmet>
                        <title>Bookings</title>
                    </Helmet>
                    <div>
                        {/* <h2 className="font-weight-bold">Bookings</h2> */}
                        <PaymentsTable />
                    </div>
                </div>
            </Route>
            <Route 
                path={`/`} 
                render={props => {
                return (
                    <div>
                        <Helmet>
                            <title>Revenue</title>
                        </Helmet>
                        <div>
                            {/* <h2 className="font-weight-bold">Revenue</h2> */}
                            <StripePaymentsTable {...props} />
                        </div>
                        
                    </div>
                )
                }} 
            />
        </Switch>
        </div>
    );
}

export default PaymentsPage;
